import {Coordinates} from '@domain/coordinates';
import {ContainerElement, pointer as d3Pointer, select as d3Select} from 'd3-selection';

export function getMouseCoordinatesInProductionScheduleBuilderGroup(event: DragEvent): Coordinates {
  const productionScheduleBuilderGroupElement = d3Select('.production-schedule-builder-group').node() as ContainerElement;
  const [mouseCoordinateX, mouseCoordinateY] = d3Pointer(event, productionScheduleBuilderGroupElement);

  return {
    x: mouseCoordinateX,
    y: mouseCoordinateY
  };
}
